var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClaimCompanyIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.7432 13.8418L65.2528 21.3176V64.2049H35.7432V13.8418Z",
    fill: "#256AF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8085 30.3671H57.1862",
    stroke: "white",
    strokeWidth: 4.15385
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8085 41.3839H57.1862",
    stroke: "white",
    strokeWidth: 4.15385
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8085 52.4012H57.1862",
    stroke: "white",
    strokeWidth: 4.15385
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8574 15.7559L48.7278 1.64453V64.2049H16.8574V15.7559Z",
    fill: "#256AF5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1035 24.8589H39.4812",
    stroke: "white",
    strokeWidth: 4.15385
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1035 35.876H39.4812",
    stroke: "white",
    strokeWidth: 4.15385
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1035 46.8926H39.4812",
    stroke: "white",
    strokeWidth: 4.15385
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.9131,
    cy: 54.0002,
    r: 16.3558,
    fill: "#6CCC93"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6875 53.256L15.6673 59.2358L26.1385 48.7646",
    stroke: "white",
    strokeWidth: 4.15385
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimCompanyIc);
export default __webpack_public_path__ + "static/media/claim-company-ic.855fe45174f14bcdbc09f2983fc3c03b.svg";
export { ForwardRef as ReactComponent };